import { Helmet } from 'react-helmet-async';

const Title = ({ title, description, canonicalPath }) => {
  const baseTitle = "Maya Devi University";
  const fullTitle = title ? `${title} | ${baseTitle}` : baseTitle;
  const defaultDescription = "Maya Devi University is the best university in Dehradun, Uttarakhand, offering top-quality education, research opportunities, and career-oriented programs.";
  const baseUrl = "https://mayadeviuniversity.com"; // Replace with your actual domain
  const canonicalUrl = canonicalPath ? `${baseUrl}${canonicalPath}` : baseUrl;
  
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};

export default Title;